const betOffers = {
    title: 'Example JSON',
    expectedOutput: '718749.9999999999',
    initialDisplayedCode: `{
	"betOffers": [{
		"id": 300,
		"eachWay": {
			"fractionMilli": 2000
		}
	}],
	"stakes": [{
		"stake": 1,
		"outcomeId": 100,
		"toWinInput": 100,
		"eachWaySelected": true,
		"type": "single"
	}],`,
    moreCode: `
	"betBuilders": [{
		"selectedOdds": {
			"decimal": 1100,
			"american": "-1000",
			"fractional": "1/10"
		},
		"selectedOutcomeIds": [100]
	}],
	"hasSelectedTeaser": false,
	"selectedOutcomes": [{
		"id": 100,
		"odds": 1100,
		"nrOfPermutations": 2,
		"betOfferId": 300
	},
	{
		"id": 101,
		"odds": 1200,
		"nrOfPermutations": 1,
		"betOfferId": 300
	}],
	"selectedReward": {},
	"selectedTab": "single"
}`,
};

export default betOffers;
